import { useState } from 'react';

/** Botão de copiar com retorno visual. Usa o fallback de textarea + execCommand porque
 *  navigator.clipboard não existe em contexto sem HTTPS (acesso por IP na rede interna). */
export default function CopiarTexto({
  texto,
  rotulo = 'Copiar',
  titulo,
  icone = 'bi-clipboard',
  classe = 'wh-btn wh-btn-outline wh-btn-sm',
}) {
  const [copiado, setCopiado] = useState(false);

  const copiar = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(texto);
      } else {
        const area = document.createElement('textarea');
        area.value = texto;
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
      }
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1800);
    } catch {
      window.prompt('Copie manualmente:', texto);
    }
  };

  return (
    <button type="button" className={classe} onClick={copiar} title={titulo || rotulo}>
      <i className={`bi ${copiado ? 'bi-check2' : icone}`} />
      {/* botão só de ícone não vira "Copiado" — a troca do ícone já é o retorno visual, e o
          texto mudaria a largura do botão dentro da tabela */}
      {copiado ? (rotulo ? 'Copiado' : '') : rotulo}
    </button>
  );
}
